import { render, staticRenderFns } from "./estado_declaracion_admin.vue?vue&type=template&id=07c7f66c"
import script from "./estado_declaracion_admin.js?vue&type=script&lang=js&external"
export * from "./estado_declaracion_admin.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports